import { useGigyaStore } from '@stores/gigya'

export const signOutAccount = (): Promise<void> => {
  return new Promise(resolve => {
    window.gigya?.accounts.logout({
      callback: () => {
        resolve()
      },
    })
  })
}

export const useGigyaSignOutUser = () => {
  const [_, setGigyaStore] = useGigyaStore()

  const signOutUser = async () => {
    try {
      await signOutAccount()
      setGigyaStore({ user: null })
    } catch (error) {
      console.error('Signout error:', error)
    }
  }

  return { signOutUser }
}
